<template>
  <div>
    <v-data-table
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      dense
      class="elevation-1"
      :headers="headers"
      :items="brandTypes"
      :loading="loading"
      loading-text="Loading brand types..."
    >
      <template v-slot:item.actions="{ item }">
        <v-btn text icon @click="$emit('editBrandType', item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn text icon @click="confirmDelete(item.id)">
          <v-icon color="red">
            mdi-delete
          </v-icon>
        </v-btn>
        <v-btn text icon @click="openSettings(item)">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <template #item.id="{ index }">
        <span>{{ index + 1 + itemsPerPage * (page - 1) }}</span>
      </template>
    </v-data-table>
    <v-dialog v-model="settingsDialog" width="400">
      <stock-brand-type-settings
        :stock-brand-type-id="selectedBrandType"
        @close="settingsDialog = false"
        @updated="fetchBrandTypes"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from '@/extra-functions/axios.extra'
import { ConfirmPopup, ErrorPopup, SuccessPopup } from '../../../../lib/utils'

export default {
  name: 'IndexStockBrandType',
  components: {
    StockBrandTypeSettings: () => import('./settings/Create'),
  },
  data() {
    return {
      brandTypes: [],
      loading: false,
      headers: [
        { text: '#', value: 'id', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      page: 1,
      itemsPerPage: 10,
      settingsDialog: false,
      selectedBrandType: null,
    }
  },
  created() {
    this.fetchBrandTypes()
  },
  methods: {
    async fetchBrandTypes() {
      this.loading = true
      try {
        const { data } = await axios(this.$store.state.auth.token).get(
          '/stock-brand-types',
        )
        this.brandTypes = data
      } catch (error) {
        this.$alertSwalError('Failed to load stock brand types.')
      } finally {
        this.loading = false
      }
    },
    async confirmDelete(id) {
      const { isConfirmed: confirmed } = await ConfirmPopup.fire(
        'Are you sure you want to delete this brand type?',
      )
      if (!confirmed) return

      try {
        await axios(this.$store.state.auth.token).delete(
          `/stock-brand-types/${id}`,
        )
        this.fetchBrandTypes()
        SuccessPopup.fire({
          title: 'Brand Type Deleted',
          text: 'The stock brand type has been successfully deleted.',
        })
        this.$emit('deleted')
      } catch (error) {
        if (error instanceof Error) console.log(error.message)
        ErrorPopup.fire('Failed to delete brand type.')
      }
    },
    openSettings(item) {
      this.selectedBrandType = item.id
      this.settingsDialog = true
    },
  },
}
</script>
